import { Input } from "@visiblethread/react-components";
import RadioCards from "components/RadioCards";
import { bool, func, object } from "prop-types";

import classes from "./DocumentDetachOptions.module.scss";

const DocumentDetachOptions = ({
  deleteDocument,
  detachParams = {},
  onChangeDelete,
  onUpdateFileNames,
}) => {
  const onChangeValue = (documentId) => (value) => {
    onUpdateFileNames((state) => {
      const updated = { ...state, [documentId]: value };
      return updated;
    });
  };

  return (
    <>
      <RadioCards
        className={classes["document_detach_options"]}
        idPrefix="document_detach"
        onChange={onChangeDelete}
        options={[
          {
            label: (
              <>
                I want to <strong>delete</strong> old child associated doc(s)
              </>
            ),
            value: true,
          },
          {
            align: "start",
            label: (
              <>
                <>
                  I want to <strong>Keep</strong> old child associated doc(s)
                </>
                {Object.keys(detachParams).map((documentId, index) => {
                  const value = detachParams[documentId];
                  return (
                    <Input
                      className={classes["document_detach_input"]}
                      disabled={deleteDocument || deleteDocument === undefined}
                      key={documentId || index}
                      label={`Name of Detached Doc No. ${index + 1}`}
                      onChange={onChangeValue(documentId)}
                      value={value}
                    />
                  );
                })}
              </>
            ),
            value: false,
          },
        ]}
        value={deleteDocument}
      />
    </>
  );
};

DocumentDetachOptions.propTypes = {
  deleteDocument: bool,
  detachParams: object,
  onChangeDelete: func,
  onUpdateFileNames: func,
};

export default DocumentDetachOptions;
